import React from 'react';
import {connect} from 'react-redux';
import Modal from '../Modal';
import CLForm from '../CLForm';
import FLGForm from '../CLForm/FLGForm';
import { toggleFormModal, installApp, fetchApps, saveSettings } from '../../actions';
import './cl-modal.css';
import WithNotifications from 'containers/WithNotifications';

const CLModal = ({ app, apps, form, toggleFormModal, installApp, fetchApps, saveSettings, detectedBrowser, config, isOpen, addNotification }) => {
  const formFields = form === 'install' ? app.preInstall : app.configuration;

  const onSubmit = (values) => {
    if(form === 'install'){
      installApp(app,values)
        .then(() => addNotification('success',`${app ? app.name : 'App'} installed successfully`))
        .then(() => fetchApps())
        .catch((err) => addNotification('error', 'There was a problem installing the integration'));
    }
    if(form === 'configure'){
      saveSettings(app.appInstallationID, values);
    }
    toggleFormModal()
  }

  const renderBrowserName = (browser) => {
    return `${browser[0].toUpperCase()}${browser.substring(1).toLowerCase()}`;
  }

  const renderSubtitle = () => {
    if(detectedBrowser && !config) return `Install the CircleLoop ${renderBrowserName(detectedBrowser)} extension`;
    if(form === 'configure') return 'Configure your integration to fit your needs'
    return 'Please enter the following details';
  }

  const useFLGInstallForm = () => {
    return ['flg','flgDev'].indexOf(app.source) > -1 && form === 'install'
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={toggleFormModal}>
      <div className="require-api-key-view">
        <div className="title-section">
          <img src={app.logoGraphic} alt="Logo" className="app-logo-small"/>
          <div className="text-section">
            <h2>{app.name}</h2>
            <p>{`${renderSubtitle()}`}</p>
          </div>
        </div>
        {config ? 
          useFLGInstallForm() ?
          <FLGForm fields={formFields} onSubmit={onSubmit} existingDomains={app.existingDomains}/> :
          <CLForm fields={formFields} onSubmit={onSubmit} app={app} />
        : null}
        {detectedBrowser ?
          <div className="install-extension-view">
            <div className='text-block'>
              <h1>CircleLoop browser extension</h1>
              <p>{`Install our ${renderBrowserName(detectedBrowser)} extension to get more features`}</p>
            </div>
            <a href={apps.find(app => app.source === detectedBrowser).link} target="_blank" className="cl-button cl-button-a-tag">
              {`Install ${renderBrowserName(detectedBrowser)} extension`}
            </a>
          </div>
        : null}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state,ownProps) => {
  return {
    apps: state.apps,
    app: state.apps.filter(app => app.ID === ownProps.appID)[0],
    detectedBrowser: state.ui.detectedBrowser,
    config: state.ui.config
  }
} 

export default WithNotifications(connect(mapStateToProps, { toggleFormModal, installApp, fetchApps, saveSettings })(CLModal));


// WEBPACK FOOTER //
// ./src/components/CLModal/index.js